<template lang='pug'>
  .merchant-services.component
    bf-flex.add-buttons.centered
      //- bf-flex.animation.centered.icon(v-if="hilite=='serv'")
      //-   new-icon
      //- h5 {{ $t("Add Service")}}
      
      bf-flex.centered.actionable.add-button( @click.native='show.new = true' v-show='!show.new' )
        bf-flex.icon.centered
          new-icon
        h5 {{ $t("Add Service")}}
        
      bf-flex.centered.actionable.add-button( @click.native='show.product = true' v-show='!show.product' )
        bf-flex.icon.centered
          new-icon
        h5 {{ $t("Add Product")}}

    
      bf-flex.centered.actionable.add-button( @click.native='show.catalog = true' v-show='!show.catalog' )
        bf-flex.icon.centered
          new-icon
        h5 {{ $t("Add Menu/Catalog")}}

    base-modal#new-product.form(
      :show='show.product'
    )
      set-product(
        :categories='categories'
        :account='account'
        :biz='biz'
        @set='show.product = false'
        @close='show.product = false'
        @categorize='show.product = false; $emit("categorize")'
      )

    base-modal#new-catalog.form(
      :show='show.catalog'
    )
      set-catalog(
        :categories='categories'
        :account='account'
        :biz='biz'
        @set='show.catalog = false'
        @close='show.catalog = false'
        @categorize='show.catalog = false; $emit("categorize")'
      )

    base-modal#edit-service.form(
      :show='!!show.edit'
      @close='show.edit = false'
    )
      component(
        :is='`set-${show.edit}`'
        :categories='categories'
        :account='account'
        :settable='editable'
        :biz='biz'
        @set='show.edit = false'
        @close='show.edit = false'
        @categorize='show.edit = false; $emit("categorize")'
      )
        template( v-slot:header ) {{ $t('Edit Service') }} 
        template( v-slot:footer) {{ $t('Update') }}

    .products.items
      bf-flex.item.actionable( 
        v-for='product in prods' 
        @click.native='edit( product, "products", "product" )' 
        :key='product.id' 
      )
        .delete( @click.stop='remove( product, "products" )' )
          delete-icon
        featured-image.image(collection='products' :doc='product')
        .text
          h5.title {{ product.title }}
          p.desc {{ product.description }}

    .catalogs.items
      bf-flex.item.actionable( 
        v-for='cat in cats' 
        @click.native='edit( cat, "catalogs", "catalog" )' 
        :key='cat.id' 
      )
        .delete( @click.stop='remove( cat, "catalogs" )' )
          delete-icon
        featured-image.image(collection='catalogs' :doc='cat')
        .text
          h5.title {{ cat.title }}
          p.desc {{ cat.description }}
</template>

<script>
  import { db } from '@/main'
  
  import SetService from '@/components/set-service'
  import SetProduct from '@/components/set-product'
  import SetCatalog from '@/components/set-catalog'
  import BaseModal from '@/components/modals/base'

  export default {
    name: 'merchant-services.component',

    props: [ 'account', 'categories', 'selected', 'biz', 'user' ],

    components: {
      SetService,
      SetProduct,
      SetCatalog,
      BaseModal
    },

    data() {
      return {
        collection: 'services',
        show: { new: false, edit: false, catalog: false, product: false },
        title: '',
        price: '',
        duration: '',
        description: '',
        services: [],
        key: 0,
        category_id: '',
        editable: {},
        editable_images: [],
        hilite: this.$route.params.hilight
      }
    },

    firestore() {
      return {
        services: db.collection( this.collection ).where( 'business_id', '==', this.biz.id ).orderBy( 'title' ),
        products: db.collection( 'products' ).where( 'business_id', '==', this.biz.id ).orderBy( 'title' ),
        catalogs: db.collection( 'catalogs' ).where( 'business_id', '==', this.biz.id ).orderBy( 'title' )
      }
    },

    computed: {
      srvs() {
        if ( this.selected == 'all' ) return this.services
        else return this.services.filter( s => s.category_id == this.selected.id )
      },

      prods() {
        if ( this.selected == 'all' ) return this.products
        else return this.products.filter( s => s.category_id == this.selected.id )
      },

      cats() {
        if ( this.selected == 'all' ) return this.catalogs
        else return this.catalogs.filter( s => s.category_id == this.selected.id )
      }
    },

    methods: {
      remove( doc, collection='services' ) {
        db.collection( collection ).doc( doc.id ).delete()
      },

      edit( doc, collection='services', type='service' ) {
        this.editable = doc
        this.editable_images = []
        db.collection( collection ).doc( doc.id ).collection('images').get().then( docs =>
          docs.forEach( doc => this.editable_images.push( doc.data() ) )
        )
        console.log(type);
        this.show.edit = type
      }
    },
  }
</script>
<style scoped lang='stylus'>
  .merchant-services
    margin-top 16px
    .add-buttons
      background rgb( 240 240 240 )
      border 1px solid rgb( 200 200 200 )
      padding 8px
      border-radius 12px
      .add-button
        margin-left 32px
        &:first-child
          margin 0
      .icon
        border-radius 50%
        color rgb( 90 90 90 )
        background white
        height 33px
        width 33px
        margin-right 10px
      .animation
        animation glowing 1300ms 5
        border-radius 50%
        background white
        margin-right 10px
        height 33px
        width 33px
  
  @keyframes glowing 
    0% 
      background-color #ffffff
      box-shadow 0 0 3px #1F4590
    50% 
      background-color #21c7ed
      box-shadow 0 0 15px #21c7ed
    100% 
      background-color #ffffff
      box-shadow: 0 0 3px #1F4590
</style>
